import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  QUERY_BUSCAR_VENTA,
  useBuscarVenta,
} from "../../../services/ventasServicios";
import { useBuscarAgendamientosDeVenta } from "../../../services/agendamientosServicios";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { Venta } from "../../venta/Venta";
import { useQueryClient } from "@tanstack/react-query";
import PagarModal from "../../pagar/PagarModal";

function ResumenDeVenta({
  idVenta,
  onCloseClick,
}: {
  idVenta: string;
  onCloseClick: () => void;
}) {
  let queryClient = useQueryClient();

  const {
    data: agendamientos,
    isLoading: agendamientosIsLoading,
    isSuccess: agendamientosIsSuccess,
    isError: agendamientosIsError,
  } = useBuscarAgendamientosDeVenta(idVenta, true);

  const {
    data: venta,
    isLoading: ventaIsLoading,
    isError: ventaIsError,
  } = useBuscarVenta(idVenta);

  const [mostrarPagarModal, setMostrarPagarModal] = useState<boolean>(false);

  const isError = agendamientosIsError || ventaIsError;

  const onPagarClick = () => {
    setMostrarPagarModal(true);
  };

  const onPagarModelCloseClick = () => {
    setMostrarPagarModal(false);
  };

  const onPagoSuccess = () => {
    queryClient.invalidateQueries([QUERY_BUSCAR_VENTA]);
    setMostrarPagarModal(false);
  };

  if (ventaIsLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return <ServerErrorModal />;
  }
  return (
    <>
      {venta && !mostrarPagarModal && (
        <Modal show={true} centered size="lg">
          <Modal.Body>
            {venta && (
              <Venta
                venta={venta}
                agendamientos={agendamientos}
                agendamientosIsLoading={agendamientosIsLoading}
                agendamientosIsSuccess={agendamientosIsSuccess}
                onPagarClick={onPagarClick}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={onCloseClick}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {mostrarPagarModal && venta && (
        <PagarModal
          venta={venta}
          onRegistrarPago={onPagoSuccess}
          onCloseClick={onPagarModelCloseClick}
        />
      )}
    </>
  );
}

export default ResumenDeVenta;
